import type { ReactNode } from 'react';

interface ClaimAlertMarkProps {
  color: string;
  children: ReactNode;
}

export const ClaimAlertMark = ({ color, children }: ClaimAlertMarkProps) => (
  <span
    aria-hidden="true"
    style={{
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: 18,
      height: 18,
      flexShrink: 0,
      borderRadius: '50%',
      backgroundColor: color,
      color: 'white',
    }}
  >
    <span
      style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        height: '100%',
        lineHeight: 0,
        transform: 'translateY(-0.5px)',
      }}
    >
      {children}
    </span>
  </span>
);
